import { getUserFields } from "components/user/config";
import { formatDateForDisplay } from "@/lib/utils";
import { TagCell } from "components/cell/tag/cell";

export const TITLE = "Table";

export const COLUMNS = [
  {
    id: "date",
    header: "Date",
    accessorKey: "date",
    sortable: true,
    cell: (info) => formatDateForDisplay(info.getValue()),
  },
  {
    id: "logged_hours",
    header: "Logged",
    accessorKey: "logged_hours",
    sortable: true,

    cell: (info) => {
      const hours = info.getValue();
      return hours ? hours : "0";
    },
  },
  {
    id: "tag",
    header: "Tag",
    accessorKey: "tag",
    sortable: true,
    cell: TagCell,
  },
];

export const FIELDS = [
  "id",
  "logged_hours",
  "date",
  "tag.id",
  "tag.label",
  "tag.color",
  getUserFields("employee"),
];

export const DEFAULT_FILTERS = {
  employee: "$CURRENT_USER",
  logged_hours: {
    _gt: 0,
  },
};
